import axios from "axios";
import qs from "qs";
import { BASE_URL } from "../_constants/urlConstants";
import { CONTRACTOR } from "../_constants/actionConstants";
import raiseError from "./raiseError";
import raiseWarning from "./raiseWarning";

const add = (newContractor) => async (dispatch) => {
  dispatch({ type: CONTRACTOR.ADD });
  const apiEndpoint = `${BASE_URL}/api/Contractors`;
  try {
    const res = await axios.post(apiEndpoint, newContractor);
    if (res.data.message) {
      dispatch({ type: CONTRACTOR.ADD_REJECTED });
      raiseWarning(CONTRACTOR.ADD_REJECTED, res.data.message);
    } else {
      dispatch({ type: CONTRACTOR.ADD_FULFILLED });
      return res.data;
    }
  } catch (err) {
    raiseError(CONTRACTOR.ADD_REJECTED, err.response.data);
  }
};

const getPaged =
  (tabId, page, pageSize, searchString, resetList = true) =>
  async (dispatch) => {
    dispatch({ type: CONTRACTOR.FETCH_ALL });
    const apiEndpoint = `${BASE_URL}/api/Contractors/Paged`;
    try {
      const res = await axios.get(apiEndpoint, {
        params: { page, pageSize, searchString },
        paramsSerializer: (params) => qs.stringify(params),
      });
      dispatch({
        type: CONTRACTOR.FETCH_ALL_FULFILLED,
        contractorList: res.data.contractorList,
        resetList,
        tabId,
        searchString,
      });
      return res.data.pageCount;
    } catch (err) {
      raiseError(CONTRACTOR.FETCH_ALL_REJECTED, err.response.data);
    }
  };

const getAllForProject = (projectId) => async (dispatch) => {
  dispatch({ type: CONTRACTOR.FETCH_ALL_FOR_PROJECT });
  const apiEndpoint = `${BASE_URL}/api/Project/${projectId}/Contractors`;
  try {
    const res = await axios.get(apiEndpoint);
    dispatch({
      type: CONTRACTOR.FETCH_ALL_FOR_PROJECT_FULFILLED,
      projContractorList: res.data,
      projectId,
    });
    return;
  } catch (e) {
    raiseError(CONTRACTOR.FETCH_ALL_FOR_PROJECT_REJECTED, e.response.data);
  }
};

const deleteContractor = (contractorId) => async (dispatch) => {
  dispatch({ type: CONTRACTOR.DELETE });
  const apiEndpoint = `${BASE_URL}/api/Contractors/${contractorId}`;
  try {
    const res = await axios.delete(apiEndpoint);
    if (res.data.message) {
      dispatch({ type: CONTRACTOR.DELETE_REJECTED });
      raiseWarning(CONTRACTOR.DELETE_REJECTED, res.data.message);
    } else {
      dispatch({ type: CONTRACTOR.DELETE_FULFILLED, contractorId });
    }
    return;
  } catch (err) {
    raiseError(CONTRACTOR.DELETE_REJECTED, err.response.data);
  }
};

const getDetails = (contractorId) => async (dispatch) => {
  dispatch({ type: CONTRACTOR.FETCH_DETAILS });
  const apiEndpoint = `${BASE_URL}/api/Contractors/${contractorId}`;
  try {
    const res = await axios.get(apiEndpoint);
    dispatch({
      type: CONTRACTOR.FETCH_DETAILS_FULFILLED,
      contractorId,
      payload: res.data,
    });
    return;
  } catch (e) {
    raiseError(CONTRACTOR.FETCH_DETAILS_REJECTED, e.response?.data);
    dispatch({ type: CONTRACTOR.FETCH_DETAILS_REJECTED, contractorId });
  }
};

const update = (contractor) => async (dispatch) => {
  dispatch({ type: CONTRACTOR.EDIT });
  const apiEndpoint = `${BASE_URL}/api/Contractors`;
  try {
    const res = await axios.put(apiEndpoint, contractor);
    if (res.data.message) {
      dispatch({ type: CONTRACTOR.EDIT_REJECTED });
      raiseWarning(CONTRACTOR.EDIT_REJECTED, res.data.message);
    } else {
      dispatch({
        type: CONTRACTOR.EDIT_FULFILLED,
        contractorId: contractor.contractorId,
        contractorDetails: res.data, // updated contractorDetails
      });
    }
  } catch (err) {
    raiseError(CONTRACTOR.EDIT_REJECTED, err.response.data);
  }
};

// This action also adds ProjectContractor
const updateProjectContractorSelection = (projectId, pcDtos) => async (dispatch) => {
  dispatch({ type: CONTRACTOR.EDIT_PROJECT_CONTRACTORS });
  const apiEndpoint = `${BASE_URL}/api/Project/${projectId}/Contractors`;
  try {
    const res = await axios.put(apiEndpoint, pcDtos);
    if (res.data.message) {
      dispatch({ type: CONTRACTOR.EDIT_PROJECT_CONTRACTORS_REJECTED });
      raiseWarning(CONTRACTOR.EDIT_PROJECT_CONTRACTORS_REJECTED, res.data.message);
    } else {
      dispatch({ type: CONTRACTOR.EDIT_PROJECT_CONTRACTORS_FULFILLED });
    }
  } catch (err) {
    raiseError(CONTRACTOR.EDIT_PROJECT_CONTRACTORS_REJECTED, err.response.data);
  }
};

const updateProjectContractorDetails = (pc) => async (dispatch) => {
  dispatch({ type: CONTRACTOR.EDIT_PROJECT_CONTRACTOR_DETAILS });
  const apiEndpoint = `${BASE_URL}/api/Project/${pc.projectId}/Contractor`;
  try {
    const res = await axios.put(apiEndpoint, pc);
    if (res.data.message) {
      dispatch({ type: CONTRACTOR.EDIT_PROJECT_CONTRACTOR_DETAILS_REJECTED });
      raiseWarning(CONTRACTOR.EDIT_PROJECT_CONTRACTOR_DETAILS_REJECTED, res.data.message);
    } else {
      dispatch({
        type: CONTRACTOR.EDIT_PROJECT_CONTRACTOR_DETAILS_FULFILLED,
        projContractorDetails: res.data,
        contractorId: pc.contractorId,
        projectId: pc.projectId,
      });
    }
  } catch (err) {
    raiseError(CONTRACTOR.EDIT_PROJECT_CONTRACTOR_DETAILS_REJECTED, err.response.data);
  }
};

// Keep this interface alphabetical
const contractorActions = {
  add,
  deleteContractor,
  getAllForProject,
  getDetails,
  getPaged,
  update,
  updateProjectContractorDetails,
  updateProjectContractorSelection,
};

export default contractorActions;
